/**
 * Iter89l (2026-02-24) — Rich-Text-Editor: Placeholder-Chip-Registry.
 *
 * Zentrale Registry aller `${…}` Platzhalter, die im Editor als Chips
 * eingefügt werden können. Der Template-Renderer (PDF/Word) ersetzt sie
 * durch die tatsächlichen Werte aus Projekt / Kunde / Angebot.
 *
 * ACHTUNG: Dies ist Phase 1 (Fundament). Der PDF-Renderer selbst muss in
 * einer Folge-Session an diese Registry angebunden werden — bis dahin
 * werden Placeholder als Literal-Strings gerendert.
 */

export const PLACEHOLDER_CATEGORIES = [
  {
    id: "customer",
    label: "Kunde",
    placeholders: [
      { key: "kunde.anrede",       label: "Anrede",       example: "Herr" },
      { key: "kunde.vorname",      label: "Vorname",      example: "Christof" },
      { key: "kunde.nachname",     label: "Nachname",     example: "Schirm" },
      { key: "kunde.email",        label: "E-Mail",       example: "c.schirm@example.de" },
      { key: "kunde.telefon",      label: "Telefon",      example: "+49 170 000 0001" },
      { key: "kunde.kundennummer", label: "Kundennummer", example: "26-4711" },
    ],
  },
  {
    id: "object",
    label: "Objekt",
    placeholders: [
      { key: "objekt.strasse",  label: "Straße + Nr.", example: "Musterweg 12" },
      { key: "objekt.plz",      label: "PLZ",          example: "26603" },
      { key: "objekt.ort",      label: "Ort",          example: "Aurich" },
      { key: "objekt.adresse",  label: "Volle Anschrift", example: "Musterweg 12, 26603 Aurich" },
    ],
  },
  {
    id: "offer",
    label: "Auftrag / Angebot",
    placeholders: [
      { key: "auftrag.nummer",     label: "Auftrags-/Angebots-Nr.", example: "2607333-0003" },
      { key: "auftrag.datum",      label: "Auftrags-Datum",         example: "23.08.2026" },
      { key: "auftrag.brutto",     label: "Auftragssumme brutto",   example: "30.677,71 €" },
      { key: "auftrag.produkt",    label: "Produkt (WP-Modell)",    example: "Vaillant aroTHERM plus VWL 75/6" },
    ],
  },
  {
    id: "invoice",
    label: "Rechnung",
    placeholders: [
      { key: "rechnung.nummer",   label: "Rechnungs-Nr.", example: "2607333-0003-AZ2" },
      { key: "rechnung.datum",    label: "Rechnungs-Datum", example: "20.09.2026" },
      { key: "rechnung.prozent",  label: "Anteil (%)", example: "30" },
      { key: "rechnung.brutto",   label: "Rechnungs-Betrag brutto", example: "9.203,31 €" },
      { key: "rechnung.faellig",  label: "Fällig am", example: "04.10.2026" },
    ],
  },
  {
    id: "tenant",
    label: "Mandant (Firma)",
    placeholders: [
      { key: "firma.name",     label: "Firmenname",         example: "NOVATUS Energie GmbH" },
      { key: "firma.iban",     label: "IBAN",               example: "DE12 3456 7890 …" },
      { key: "firma.email",    label: "E-Mail",             example: "info@novatussales.pro" },
      { key: "firma.telefon",  label: "Telefon",            example: "+49 4941 000 000" },
      { key: "firma.geschaeftsfuehrer", label: "Geschäftsführer", example: "Christof Schirm" },
    ],
  },
];

// Convenience — flache Liste aller Placeholder-Keys
export const ALL_PLACEHOLDER_KEYS = PLACEHOLDER_CATEGORIES.flatMap(c =>
  c.placeholders.map(p => p.key)
);

/**
 * Ersetzt `${key}`-Placeholder in einem HTML-String durch Werte aus
 * `context`. Reine Frontend-Preview-Funktion. Der finale PDF-Renderer
 * muss serverseitig dieselbe Ersetzung durchführen (Duplikat-Logik zu
 * vermeiden ist Ziel von Phase 2b).
 */
export function renderPlaceholders(html, context = {}) {
  if (!html) return "";
  return html.replace(/\$\{([a-zA-Z0-9_.]+)\}/g, (_, key) => {
    const val = context[key];
    return val != null ? String(val) : `\${${key}}`;
  });
}
